import { createElement } from 'react';
import PropTypes from 'prop-types';
import styles from './styles';
import createStyle from '../../Utils/createStyle';

const useStyles = createStyle(styles);

export default function Grid({
  taghtml,
  children,
  className,
  justify,
  align,
  content,
  reverse,
  gutters,
  direction,
  noWrap,
  ...props
}) {
  const cls = useStyles();
  const mainCls = 'grid';
  const classes = [
    mainCls,
    className,
    cls.grid,
    justify ? cls[`${mainCls}--justify-${justify}`] : '',
    align ? cls[`${mainCls}--align-${align}`] : '',
    content ? cls[`${mainCls}--content-${content}`] : '',
    reverse ? cls[`${mainCls}--reverse`] : '',
    gutters ? cls[`${mainCls}--gutters-${gutters}`] : '',
    direction ? cls[`${mainCls}--direction-${direction}`] : '',
    noWrap ? cls[`${mainCls}--no-wrap`] : '',
  ].filter(c => c).join(' ').trim();

  return createElement(
          (taghtml || 'div'),
          {
            className: classes,
            ...props,
          },
          children,
        );
};

Grid.propTypes = {
  /**
   * Optional: html tag to use (defaults to div)
   */   
  taghtml: PropTypes.string,
  className: PropTypes.string,
  justify: PropTypes.oneOf(['', 'flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),
  align: PropTypes.oneOf(['', 'stretch', 'flex-start', 'flex-end', 'center', 'baseline']),
  content: PropTypes.oneOf(['', 'stretch', 'flex-start', 'flex-end', 'center', 'space-between', 'space-around']),
  direction: PropTypes.oneOf(['', 'row', 'row-reverse', 'column', 'column-reverse']),
  gutters: PropTypes.oneOf(['', 's', 'sm', 'm', 'l']),
  reverse: PropTypes.bool,
  noWrap: PropTypes.bool,
}

Grid.defaultProps = {
  taghtml: null,
  className: '',
  justify: '',
  align: '',
  content: '',
  gutters: '',
  direction: '',
  reverse: false,
  noWrap: false,
}
